module.exports = __webpack_public_path__ + "img/newsImg11-13.49e05af0.png";